/* import __COLOCATED_TEMPLATE__ from './rest-pull-bom-source.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();